import * as server from "@/utils/http"

export const _schoolsList = params => server.get("/schools/list", params);
export const _gradesList = params => server.get("/grades/findBySchoolId", params);
export const _gradesAll = params => server.get("/grades/list", params);
export const _classesList = params => server.get("/classes/findByGradeId", params);
export const _classesAll = params => server.get("/classes/findBySchoolId", params);
export const _nationsList = params => server.get("/nations/list", params);
export const _applicableAgeList = params => server.get("/applicable-age/list", params);
export const _crowdList = params => server.get("/physical-crowd/list", params);
export const _reportList = params => server.get("/report-template/list", params);
export const _taskList = params => server.get("/task-info/list", params);
export const _studentsList = params => server.get("/students/list", params);

